import { useState } from 'react';
import { Review, ReviewForm } from '.';

import type { TaskAnswerReview } from 'shared-types';

interface Props {
  answerId: number;
  answerUserEmail?: string;
  courseId: number;
  gradingType: 'text' | 'text-and-stars' | 'text-and-points';
  isTaskEditable?: boolean;
  maxPoints: number;
  onDataChange: () => Promise<void>;
  onlyComments: boolean;
  review: TaskAnswerReview | null;
}

const ReviewEditable = ({
  answerId,
  answerUserEmail,
  courseId,
  gradingType,
  isTaskEditable,
  maxPoints,
  onDataChange,
  onlyComments,
  review
}: Props) => {
  const [editing, setEditing] = useState<boolean>(false);

  const handleClose = () => {
    setEditing(false);
  };

  const handleEdit = () => {
    setEditing(true);
  };

  return (
    <div className="review-editable">
      {editing || !review ? (
        <ReviewForm
          answerId={answerId}
          answerUserEmail={answerUserEmail}
          courseId={courseId}
          gradingType={gradingType}
          isTaskEditable={isTaskEditable}
          maxPoints={maxPoints}
          onClose={handleClose}
          onlyComments={onlyComments}
          onSuccess={onDataChange}
          review={review}
        />
      ) : (
        <Review
          courseId={courseId}
          isAdmin={true}
          onEdit={handleEdit}
          onDataChange={onDataChange}
          review={review}
        />
      )}
    </div>
  );
};

export default ReviewEditable;
